import * as C from "react";
import { forwardRef as o } from "react";
const n = o(function(L, e) {
  return /* @__PURE__ */ C.createElement(
    "svg",
    {
      fill: "none",
      ref: e,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...L
    },
    /* @__PURE__ */ C.createElement(
      "path",
      {
        d: "M11.1217 11.3581L12.2495 12.5426L11.5931 13.2324C11.905 13.8268 11.8483 14.5769 11.4208 15.1126L11.3235 15.224L6.17079 20.6319C5.96137 20.8518 5.68165 20.9824 5.38577 20.9984C5.0899 21.0143 4.79891 20.9144 4.56915 20.7181L4.47902 20.6319L3.35037 19.4482C3.14102 19.2284 3.01675 18.935 3.00157 18.6247C2.9864 18.3144 3.0814 18.0091 3.26821 17.768L3.35037 17.6726L8.50307 12.2647C8.75863 11.996 9.0936 11.8265 9.45302 11.7839C9.81245 11.7413 10.175 11.8282 10.4812 12.0303L11.1217 11.3581ZM5.48403 3.73171C6.10619 3.07874 6.86394 2.81336 7.17581 3.13985C7.38479 3.35918 7.34012 3.78863 7.10003 4.24487L14.5188 12.0303C14.825 11.8282 15.1876 11.7413 15.547 11.7839C15.9064 11.8265 16.2414 11.996 16.4969 12.2647L21.6496 17.6726L21.7318 17.768C21.9186 18.0091 22.0136 18.3144 21.9984 18.6247C21.9833 18.935 21.859 19.2284 21.6496 19.4482L20.5218 20.6319L20.4309 20.7181C20.2011 20.9142 19.9103 21.0139 19.6146 20.998C19.3189 20.982 19.0394 20.8516 18.83 20.6319L13.6773 15.224L13.58 15.1126C13.3744 14.8538 13.2479 14.536 13.217 14.2006C13.1861 13.8651 13.2523 13.5278 13.4069 13.2324L5.97218 5.42775C5.53747 5.6789 5.12829 5.72578 4.91931 5.50728C4.60823 5.1808 4.86108 4.38551 5.48403 3.73087V3.73171ZM19.5168 3.73171C20.1397 4.38551 20.3926 5.1808 20.0807 5.50812C19.8725 5.72661 19.4633 5.68057 19.0286 5.42859L13.9421 10.767L12.8135 9.58248L17.9008 4.24487C17.6607 3.78863 17.616 3.35918 17.825 3.13985C18.1361 2.81336 18.8938 3.0779 19.5168 3.73171Z",
        fill: "currentColor"
      }
    )
  );
});
export {
  n as Rowing
};
